import { render, staticRenderFns } from "./PlanCard.vue?vue&type=template&id=eb31c3d4&scoped=true&"
import script from "./PlanCard.vue?vue&type=script&lang=ts&"
export * from "./PlanCard.vue?vue&type=script&lang=ts&"
import style0 from "./PlanCard.vue?vue&type=style&index=0&id=eb31c3d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb31c3d4",
  null
  
)

export default component.exports
import {QCard,QChip,QCardSection,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QChip,QCardSection,QBtn})
